<template>
  <!-- 融资贷款情况 -->
  <div class="rightbox backwhite width86 border-rd3" style="min-height: 800px">
    <div class="toolbtn flex margin-right10">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton class="width100" :loading="true" animated :throttle="200">
      <template slot="template">
        <p
          class="
            flex-betweennowrap
            width98
            margin-auto margin-top20 margin-bot10
          "
        >
          <span class="dimensional">融资贷款情况</span>
          <span class="attention f14" @click="tocollectionadd()">新 增</span>
        </p>

        <el-table
          :data="page"
          stripe
          class="eltable width98 margin-auto f14"
          v-if="total != 0"
        >
          <el-table-column label="项目名称" align="left">
            <template slot-scope="scope">
              <span
                class="width100 cursorpointer bluecolor"
                @click="previewreport(scope.row)"
                >{{ scope.row.title }}
              </span></template
            >
          </el-table-column>
          <el-table-column label="融资方" align="center" prop="institution" />
          <el-table-column label="融资金额" align="center">
            <template slot-scope="scope">
              {{
                scope.row.fund == "" || null
                  ? 0 + "万元"
                  : scope.row.fund + "万元"
              }}</template
            ></el-table-column
          >
          <el-table-column
            label="融资时间"
            align="center"
            prop="finance_date"
          />
          <el-table-column label="起止日" align="center">
            <template slot-scope="scope">
              {{ scope.row.finance_date }} 至 {{ scope.row.end_time }}</template
            >
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <div class="cursorpointer flex">
                <span class="bluecolor" @click="previewreport(scope.row)"
                  >详情</span
                >
                <span
                  class="pad-left20 bluecolor"
                  @click="collectionmodify(scope.row)"
                  >修改</span
                >
                <span
                  class="pad-left20 bluecolor"
                  @click="designDetail(scope.row)"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="
            flex-betweennowrap
            width98
            margin-auto
            pad-top20 pad-bot20 pad-left10 pad-right10
          "
          v-if="total != 0"
        >
          <span class="f14" style="color: #409eff"></span>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="currentchange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="per_page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <!-- 详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetail"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorbox"
    >
      <div class="f16 width98 textalign-left dimensional">融资贷款情况</div>
      <div class="margon-auto margin-top30">
        <div class="table">
          <div class="leftboxs">项目名称 :</div>
          <div class="rightboxs">{{ title }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">融资单位 :</div>
          <div class="rightboxs">{{ institution }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">融资方式 :</div>
          <div class="rightboxs">{{ way }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">货币类型 :</div>
          <div class="rightboxs">{{ currency }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">约定利率 :</div>
          <div class="rightboxs">{{ interest_rate }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">起止时间 :</div>
          <div class="rightboxs">{{ finance_date }} 至 {{ end_time }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">币种 :</div>
          <div class="rightboxs">{{ currency }}</div>
        </div>
        <div class="table">
          <div class="leftboxs">备注 :</div>
          <div class="rightboxs">{{ remark }}</div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisibledetail = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->

    <el-dialog
      title=""
      :visible.sync="dialogVisibleadd"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">融资贷款情况新增</div>
      <div class="pad-top30">
        <div class="bg-box">
          <div>项目名称</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入项目名称"
              v-model="title"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>融资时间</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="finance_date"
              type="date"
              placeholder="请选择研发融资时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
        </div>

        <div class="bg-box">
          <div>融资金额</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入融资金额 单位万元"
              v-model="fund"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>利率</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入利率 如 0.002"
              v-model="interest_rate"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>投资机构</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入融资机构名称"
              v-model="institution"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>融资方式</div>
          <div class="box-right">
            <el-select
              v-model="way"
              placeholder="请选择融资方式"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="bg-box">
          <div>融资货币</div>
          <div class="box-right">
            <el-select
              v-model="currency"
              placeholder="请选择货币类型"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in optionss"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="bg-box">
          <div>到期时间</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="end_time"
              type="date"
              placeholder="请选择到期时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              :picker-options="pickerOptionss"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>备注</div>

          <div class="box-right">
            <el-input
              placeholder="请输入项目备注"
              v-model="remark"
              type="textarea"
              :autosize="autosize"
              class="inputDeep"
              maxlength="500"
              @input="monitorInputs"
              rows="5"
              cols="20"
            >
            </el-input>
            <span class="numLimits">{{ nums }}/200</span>
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisibleadd = false">取 消</el-button>
        <el-button type="primary" @click="Savechanges()"> 确 定 </el-button>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblemodify"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <div class="f16 width98 textalign-left dimensional">融资贷款情况修改</div>
      <div class="pad-top30">
        <div class="bg-box">
          <div>项目名称</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入项目名称"
              v-model="title"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>融资时间</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="finance_date"
              type="date"
              placeholder="请选择研发融资时间"
              value-format="yyyy-MM-dd"
              :editable="false"
            ></el-date-picker>
          </div>
        </div>

        <div class="bg-box">
          <div>融资金额</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入融资金额 单位万元"
              v-model="fund"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>利率</div>
          <div class="box-right">
            <el-input
              type="number"
              class="inputDeep"
              placeholder="请输入利率 如 0.002"
              v-model="interest_rate"
            />
          </div>
        </div>

        <div class="bg-box">
          <div>投资机构</div>
          <div class="box-right">
            <el-input
              class="inputDeep"
              placeholder="请输入融资机构名称"
              v-model="institution"
            />
          </div>
        </div>
        <div class="bg-box">
          <div>融资方式</div>
          <div class="box-right">
            <el-select
              v-model="way"
              placeholder="请选择融资方式"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="bg-box">
          <div>融资货币</div>
          <div class="box-right">
            <el-select
              v-model="currency"
              placeholder="请选择货币类型"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in optionss"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="bg-box">
          <div>到期时间</div>
          <div class="box-right">
            <el-date-picker
              class="inputDeep"
              v-model="end_time"
              type="date"
              placeholder="请选择到期时间"
              value-format="yyyy-MM-dd"
              :editable="false"
            ></el-date-picker>
          </div>
        </div>
        <div class="bg-box">
          <div>备注</div>

          <div class="box-right">
            <el-input
              placeholder="请输入项目备注"
              v-model="remark"
              type="textarea"
              :autosize="autosize"
              class="inputDeep"
              maxlength="500"
              @input="monitorInputs"
              rows="5"
              cols="20"
            >
            </el-input>
            <span class="numLimits">{{ nums }}/200</span>
          </div>
        </div>
      </div>
      <div class="textalign-right margin-top20">
        <el-button @click="dialogVisiblemodify = false">取 消</el-button>
        <el-button class="" type="primary" @click="Savechangemodify()">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 错误弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  entfinanceindex,
  entfinancedelete,
  entfinancedetail,
  entfinancesave,
  entfinanceupdate,
} from "@/api/business/business.api";
import callback from "@/components/callback.vue";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      dialogVisibledetail: false,
      options: [
        {
          value: 1,
          label: "银行贷款",
        },
        {
          value: 2,
          label: "小贷公司贷款",
        },
        {
          value: 3,
          label: "P2P融资",
        },
        {
          value: 4,
          label: "融资租赁",
        },
        {
          value: 5,
          label: "股票筹资",
        },
        {
          value: 6,
          label: "债务融资",
        },
        {
          value: 7,
          label: "信用担保融资",
        },
        {
          value: 8,
          label: "股权融资",
        },
        {
          value: 9,
          label: "增资扩股",
        },
        {
          value: 10,
          label: "产权交易",
        },
        {
          value: 11,
          label: "票据贴现",
        },
        {
          value: 12,
          label: "贸易融资",
        },
        {
          value: 13,
          label: "供应链融资",
        },
        {
          value: 14,
          label: "信托融资",
        },
      ],
      optionss: [
        {
          value: 1,
          label: "人民币",
        },
        {
          value: 2,
          label: "美元",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      title: "",
      institution: "",
      finance_date: "",
      way: "",
      currency: "",
      fund: "",
      interest_rate: "",
      end_time: "",
      remark: "",
      nums: 200,

      dialogVisibleadd: false,
      dialogVisiblemodify: false,
      modifyid: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      pickerOptionss: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  components: {
    callback,
  },
  methods: {
    monitorInputs() {
      var txtVal = this.remark.length;
      this.nums = txtVal;
    },
    monitorInputss() {
      var txtVal = this.remark.length;
      this.numss = 200 - txtVal;
    },
    // 详情
    previewreport(row) {
      this.dialogVisibledetail = true;
      entfinancedetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.institution = res.data.data.institution;
          this.finance_date = res.data.data.finance_date;
          if (res.data.data.way == 1) {
            this.way = "银行贷款";
          } else if (res.data.data.way == 2) {
            this.way = "小贷公司贷款";
          } else if (res.data.data.way == 3) {
            this.way = "P2P融资";
          } else if (res.data.data.way == 4) {
            this.way = "融资租赁";
          } else if (res.data.data.way == 5) {
            this.way = "股票筹资";
          } else if (res.data.data.way == 6) {
            this.way = "债务融资";
          } else if (res.data.data.way == 7) {
            this.way = "信用担保融资";
          } else if (res.data.data.way == 8) {
            this.way = "股权融资";
          } else if (res.data.data.way == 9) {
            this.way = "增资扩股";
          } else if (res.data.data.way == 10) {
            this.way = "产权交易";
          } else if (res.data.data.way == 11) {
            this.way = "票据贴现";
          } else if (res.data.data.way == 12) {
            this.way = "贸易融资";
          } else if (res.data.data.way == 13) {
            this.way = "供应链融资";
          } else if (res.data.data.way == 14) {
            this.way = "信托融资";
          }
          if (res.data.data.currency == 1) {
            this.currency = "人民币";
          } else if (res.data.data.currency == 2) {
            this.currency = "美元";
          } else {
            this.currency = "其它";
          }
          this.fund = res.data.data.fund;
          this.interest_rate = res.data.data.interest_rate;
          this.end_time = res.data.data.end_time;
          this.remark = res.data.data.remark;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 新增
    tocollectionadd() {
      this.dialogVisibleadd = true;
      this.title = "";
      this.institution = "";
      this.finance_date = "";
      this.way = "";
      this.currency = "";
      this.fund = "";
      this.interest_rate = "";
      this.end_time = "";
      this.remark = "";
      this.nums = 200;
    },
    Savechanges() {
      entfinancesave({
        title: this.title,
        institution: this.institution,
        finance_date: this.finance_date,
        way: this.way,
        currency: this.currency,
        fund: this.fund,
        interest_rate: this.interest_rate,
        end_time: this.end_time,
        remark: this.remark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisibleadd = false;
          this.dialogVisiblemodify = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 修改
    collectionmodify(row) {
      this.dialogVisiblemodify = true;
      this.modifyid = row.id;
      entfinancedetail({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 200) {
          this.title = res.data.data.title;
          this.institution = res.data.data.institution;
          this.finance_date = res.data.data.finance_date;
          if (res.data.data.way == 1) {
            this.way = "银行贷款";
          } else if (res.data.data.way == 2) {
            this.way = "小贷公司贷款";
          } else if (res.data.data.way == 3) {
            this.way = "P2P融资";
          } else if (res.data.data.way == 4) {
            this.way = "融资租赁";
          } else if (res.data.data.way == 5) {
            this.way = "股票筹资";
          } else if (res.data.data.way == 6) {
            this.way = "债务融资";
          } else if (res.data.data.way == 7) {
            this.way = "信用担保融资";
          } else if (res.data.data.way == 8) {
            this.way = "股权融资";
          } else if (res.data.data.way == 9) {
            this.way = "增资扩股";
          } else if (res.data.data.way == 10) {
            this.way = "产权交易";
          } else if (res.data.data.way == 11) {
            this.way = "票据贴现";
          } else if (res.data.data.way == 12) {
            this.way = "贸易融资";
          } else if (res.data.data.way == 13) {
            this.way = "供应链融资";
          } else if (res.data.data.way == 14) {
            this.way = "信托融资";
          }
          if (res.data.data.currency == 1) {
            this.currency = "人民币";
          } else if (res.data.data.currency == 2) {
            this.currency = "美元";
          } else {
            this.currency = "其它";
          }
          this.fund = res.data.data.fund;
          this.interest_rate = res.data.data.interest_rate;
          this.end_time = res.data.data.end_time;
          this.remark = res.data.data.remark;
          this.nums = 200 - this.remark.length;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    Savechangemodify() {
      if (this.way == "银行贷款") {
        this.way = 1;
      } else if (this.way == "小贷公司贷款") {
        this.way = 2;
      } else if (this.way == "P2P融资") {
        this.way = 3;
      } else if (this.way == "融资租赁") {
        this.way = 4;
      } else if (this.way == "股票筹资") {
        this.way = 5;
      } else if (this.way == "债务融资") {
        this.way = 6;
      } else if (this.way == "信用担保融资") {
        this.way = 7;
      } else if (this.way == "股权融资") {
        this.way = 8;
      } else if (this.way == "增资扩股") {
        this.way = 9;
      } else if (this.way == "产权交易") {
        this.way = 10;
      } else if (this.way == "票据贴现") {
        this.way = 11;
      } else if (this.way == "贸易融资") {
        this.way = 12;
      } else if (this.way == "供应链融资") {
        this.way = 13;
      } else if (this.way == "信托融资") {
        this.way = 14;
      }
      if (this.currency == "人民币") {
        this.currency = 1;
      } else if (this.currency == "美元") {
        this.currency = 2;
      } else if (this.currency == "其它") {
        this.currency = 3;
      }
      entfinanceupdate({
        id: this.modifyid,
        title: this.title,
        institution: this.institution,
        finance_date: this.finance_date,
        way: this.way,
        currency: this.currency,
        fund: this.fund,
        interest_rate: this.interest_rate,
        end_time: this.end_time,
        remark: this.remark,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisibleadd = false;
          this.dialogVisiblemodify = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 删除项目
    designDetail(row) {
      this.$confirm("此操作将删除此项目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entfinancedelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      entfinanceindex({ page: val }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entfinanceindex({ page: 1, limit: val }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      entfinanceindex({ page: this.thisNum }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    entfinanceindex({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
      <style scoped>
.table {
  width: 98%;
  display: flex;
  /* flex-wrap: wrap; */
  margin: auto;
  text-align: left;
  font-size: 14px;
  color: #4f4f4f;
  line-height: 40px;
}
.leftboxs {
  min-width: 70px;
  color: #353a44;
  padding: 0 0 0 5px;
}
.rightboxs {
  margin-left: 10px;
  color: #6a7589;
  padding: 0 0 0 5px;
}

/* 表单盒子 */
.bg-box {
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0 10px 0;
  color: #4f4f4f;
  font-size: 14px;
}
.inputDeep {
  width: 100%;
}
.box-right {
  padding-top: 5px;
  width: 100%;
  position: relative;
}
.el-select {
  width: 100%;
}
.el-input-number--small {
  width: 100%;
}
.textarea {
  width: 170%;
  height: 80px;
  border: 1px solid #efefef;
  outline: none;
  padding: 10px 0 0 5px;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__header {
  text-align: left;
}
.errorboxs >>> .el-dialog__title {
  text-align: left;
  font-size: 16px;
  color: #606266;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 10%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f1f3f9;
  height: 40px;
  font-size: 14px;
  border-radius: 3px;
}
</style>